import css from './styles.module.scss'
import Img from "next/legacy/image"
import Link from 'next/link'

const ComparatorsCard = ({ slug, firstCMS, secondCMS }) => {
  return (
    <div>
      <Link href={`/headless-cms/comparison/${slug}`}>
        <div className={css.container}>
          <div className={css.logo}>
            <Img
              src={firstCMS.logo}
              alt={firstCMS.name}
              objectFit="contain"
              layout="fill"
            />
          </div>
          <div className={css.versus}>vs</div>
          <div className={css.logo}>
            <Img
              src={secondCMS.logo}
              alt={secondCMS.name}
              objectFit="contain"
              layout="fill"
            />
          </div>
        </div>
      </Link>
    </div>
  )
}

export default ComparatorsCard
